import Input from '../../../common/Input';
import Currency from '../../../common/Currency';
import {defaultDateFormat} from '../../../common/DatePicker';
import SimpleDatePicker from "../../../common/SimpleDatePicker";

export default {
    id: 0,

    name: 'bonuses',
    _system: {
        name: 'Bonuses individual & total',
        relatedTo: 'bonuses',
    },
    date: {
        label: 'Date',
        hideLabel: true,
        placeholder: 'Add Date',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date',
            relatedTo: 'bonuses'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date',
        rules: {
            title: 'Date'
        }
    },
    amount: {
        prefix: '$',
        label: 'Amount',
        hideLabel: true,
        placeholder: 'Add Amount',
        system: {
            component: Currency,
            name: 'amount',
            relatedTo: 'bonuses'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'amount',
        rules: {
            title: 'Amount field',
            format: /^[0-9,.]+$/
        }
    },
    description: {
        label: 'Description',
        hideLabel: true,
        placeholder: 'Add Description',
        system: {
            component: Input,
            name: 'description',
            relatedTo: 'bonuses'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'description',
        rules: {
            title: 'Description field',
        },
        grid: {
            className: 'col col-7'
        }
    }
};



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/bonuses.js